module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch3",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "CT",
    attrs: {
      "id": "ch3"
    }
  }, [_c('samp', {
    staticClass: "SANS_Northwell_Clean_Regular_17"
  }, [_vm._v("Approaching the blank page")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Try not to be afraid, and be patient if this is your first approach to watercolor. You are bound to make some mistakes along the way, and you’re going to need to practice, process, and experience in order to grasp the techniques. You may get frustrated at times, and that’s why, above all, you must remember to enjoy yourself along the way!")])]), _vm._v(" "), _c('figure', {
    staticClass: "IMG-NOBOT"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "416",
      "id": "fig-pg12-2",
      "src": "images/pg12-2.jpg",
      "width": "523"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecd96f70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter3.vue
// module id = 78
// module chunks = 0